
export default function FeaturedProjects() {
  const projects = [
    {
      title: 'Modern Kitchen Renovation',
      description: 'Full kitchen backsplash using Contractor Grade Tile Adhesive and Elite Pro Grout',
      image: 'https://public.readdy.ai/ai/img_res/77a6ae0905b5d7c1b903b11018e3406f.jpg',
      tier: 'Contractor Grade',
    },
    {
      title: 'Commercial Bathroom Fit-Out',
      description: 'Large-format porcelain tiles installed with Elite Pro Adhesive for high-traffic area',
      image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20commercial%20bathroom%20interior%20with%20large-format%20grey%20porcelain%20tiles%20covering%20walls%20and%20floors%2C%20modern%20floating%20vanities%20with%20vessel%20sinks%2C%20frameless%20glass%20shower%20enclosures%2C%20and%20contemporary%20chrome%20fixtures.%20The%20space%20features%20professional%20lighting%2C%20clean%20grout%20lines%2C%20and%20a%20sophisticated%20monochromatic%20color%20palette.%20The%20design%20emphasizes%20durability%20and%20elegance%20suitable%20for%20high-traffic%20commercial%20use.&width=800&height=600&seq=proj2&orientation=landscape',
      tier: 'Elite Pro',
    },
    {
      title: 'Outdoor Patio Transformation',
      description: 'Weather-resistant tiles bonded with Elite Pro Adhesive and sealed with premium grout',
      image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20outdoor%20patio%20transformation%20featuring%20large%20weather-resistant%20stone-look%20tiles%20in%20warm%20earth%20tones%2C%20modern%20outdoor%20furniture%2C%20potted%20plants%2C%20and%20ambient%20lighting.%20The%20patio%20showcases%20professional%20tile%20installation%20with%20perfect%20alignment%20and%20consistent%20grout%20lines.%20The%20setting%20includes%20a%20pergola%20overhead%2C%20lush%20greenery%20in%20the%20background%2C%20and%20a%20welcoming%20outdoor%20living%20space%20designed%20for%20entertaining.&width=800&height=600&seq=proj3&orientation=landscape',
      tier: 'Elite Pro',
    },
    {
      title: 'Residential Bathroom Refresh',
      description: 'Classic white subway tiles with Everyday Adhesive — perfect for DIY homeowners',
      image: 'https://readdy.ai/api/search-image?query=A%20charming%20residential%20bathroom%20refresh%20with%20classic%20white%20subway%20tiles%20arranged%20in%20a%20traditional%20brick%20pattern%2C%20black%20grout%20lines%2C%20a%20vintage-style%20pedestal%20sink%2C%20chrome%20fixtures%2C%20and%20a%20framed%20mirror.%20The%20bathroom%20has%20a%20clean%2C%20timeless%20aesthetic%20with%20natural%20light%20from%20a%20frosted%20window%2C%20white%20painted%20walls%2C%20and%20wooden%20accents.%20The%20tile%20work%20demonstrates%20quality%20DIY%20craftsmanship%20in%20a%20cozy%20home%20setting.&width=800&height=600&seq=proj4&orientation=landscape',
      tier: 'Everyday',
    },
  ];

  return (
    <section className="w-full bg-white py-12 md:py-24 px-4 md:px-8 lg:px-16 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2
            className="text-[28px] md:text-[48px] font-bold text-[#1A1A1A] mb-4 md:mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Featured Projects
          </h2>
          <p
            className="text-[15px] md:text-[18px] text-[#666666] max-w-3xl mx-auto px-2"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Real projects completed with BEST products across all three tiers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 w-full"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span
                    className="bg-[#F2C612] text-[#1A1A1A] text-[11px] font-bold px-3 py-1 rounded-full whitespace-nowrap"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {project.tier}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3
                  className="text-[18px] md:text-[22px] font-bold text-[#1A1A1A] mb-3 leading-snug"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {project.title}
                </h3>
                <p
                  className="text-[14px] md:text-[15px] text-[#666666] leading-relaxed"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button — full width on mobile */}
        <div className="mt-10 md:mt-14 flex justify-center">
          <a
            href="/contact"
            className="w-full md:w-auto text-center bg-[#1A1A1A] text-white font-bold text-[15px] px-10 py-4 rounded hover:bg-[#F2C612] hover:text-[#1A1A1A] transition-colors duration-200 whitespace-nowrap cursor-pointer min-h-[48px] flex items-center justify-center"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Start Your Project
          </a>
        </div>
      </div>
    </section>
  );
}